import { PrimaryButton } from '@!/components/Button'

const CoinSubmitButton = ({ handleSubmit }) => (
  <PrimaryButton fontSize="lg" onClick={handleSubmit}>
    購入する
  </PrimaryButton>
)

export default CoinSubmitButton
